module.exports = __webpack_public_path__ + "img/carrier1.6880cd62.png";